
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.172 2.505A4 4 0 018 1.333h10.667c.353 0 .692.14.942.39l8 8c.25.25.391.59.391.944v16a4 4 0 01-4 4H8a4 4 0 01-4-4V5.333a4 4 0 011.172-2.828zM8 4a1.333 1.333 0 00-1.333 1.333v21.334A1.333 1.333 0 008 28h16a1.333 1.333 0 001.333-1.333V11.219L18.114 4H8z","fill":"#652CDF"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.667 1.333c.736 0 1.333.597 1.333 1.334v6.666h6.667a1.333 1.333 0 110 2.667h-8a1.333 1.333 0 01-1.334-1.333v-8c0-.737.597-1.334 1.334-1.334zM9.333 17.333c0-.736.597-1.333 1.334-1.333h10.666a1.333 1.333 0 010 2.667H10.667a1.333 1.333 0 01-1.334-1.334zM9.333 22.667c0-.737.597-1.334 1.334-1.334h10.666a1.333 1.333 0 010 2.667H10.667a1.333 1.333 0 01-1.334-1.333zM9.333 12c0-.736.597-1.333 1.334-1.333h2.666a1.333 1.333 0 110 2.666h-2.666A1.333 1.333 0 019.333 12z","fill":"#652CDF"}})])
          )
        }
      }
    